export const VERSION_RELOAD_FLAG = 'reload-after-version-check';
export const VERSION_CHECK_INTERVAL = 10 * 1000; // 10 seconds
